module.exports = __webpack_public_path__ + "img/notice.d3878fc8.png";